import { SET_SKETCH_TOOL_ACTIVE } from '../../constants/appTypes';

const initialState = false;

interface sketchToolActiveAction {
  active: boolean;
  type: string;
}

export function sketchToolActive(state = initialState, action: sketchToolActiveAction) {
  switch (action.type) {
    case SET_SKETCH_TOOL_ACTIVE:
      state = action.active;
      return state;
    default:
      return state;
  }
}

export default sketchToolActive;
